import { z } from "zod";

export const Palette = z
  .object({
    main: z.string(),
    light: z.string(),
    dark: z.string(),
    foreground: z.string(),
  })
  .strict();

export type Palette = z.infer<typeof Palette>;

export const PaletteFromTheme = z
  .object({
    __tp: z.string(),
  })
  .strict();

export type PaletteFromTheme = z.infer<typeof PaletteFromTheme>;

export const PaletteSetting = z.union([Palette, PaletteFromTheme]);

export type PaletteSetting = z.infer<typeof PaletteSetting>;
